<template>
    <v-app>

        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Search Form</v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-form @submit.prevent="submit">
                                    <v-row class="pa-2">

                                        <v-col lg="2" md="2" cols="12">    
                                            <v-date-input
                                                label="From Date"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi mdi-calendar-month"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="from_date.value.value"
                                                :error-messages="from_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-date-input>  
                                        </v-col>
                                        
                                        <v-col lg="2" md="2" cols="12">    
                                             <v-date-input
                                                label="To Date"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi mdi-calendar-month"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="to_date.value.value"
                                                :error-messages="to_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-date-input>
                                        </v-col>

                                

                                        <v-col lg="2" md="2" cols="12">                                
                                            <v-btn class="bg-brand w-15" type="submit" ref="searchButton">Search</v-btn>
                                        </v-col>

                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>

        <v-container>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel" >
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">CNC Merge List</v-expansion-panel-title>
                            <v-expansion-panel-text> 
                                    <v-row class="py-2">
                                    
                                        <v-col md="4" cols="12">
                                            <v-text-field
                                                v-model="search"
                                                append-inner-icon="mdi-magnify"
                                                label="Search"
                                                single-line
                                                hide-details
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="pl-2"
                                                clearable
                                            ></v-text-field>
                                        </v-col>


                                        <v-col md="5" cols="12">                                           
                                            <div class="d-flex align-center flex-column">
                                                <v-btn-group variant="outlined" density="compact" size="x-small" divided>
                                                    <v-btn prepend-icon="mdi mdi-download" variant="flat" color="success" @click="exportToCSV">CSV</v-btn>
                                                    <v-btn prepend-icon="mdi mdi-download" variant="flat" color="primary" @click="exportToExcel">EXCEL</v-btn>
                                                    <v-btn prepend-icon="mdi mdi-download" variant="flat" color="red" @click="exportToPDF">PDF</v-btn>
                                                </v-btn-group>
                                            </div>
                                        </v-col>

                                        <v-col md="3" cols="12">
                                            <div class="text-right pr-2">
                                                <v-btn
                                                    v-if="$insertAccess($route.fullPath)"
                                                    @click="goTo('/purchase/cnc-requisition-merge')"
                                                    color="primary"
                                                    variant="tonal"
                                                    prepend-icon="mdi mdi-plus"
                                                    rounded="xl"
                                                >
                                                    Create Req Merge
                                                </v-btn>
                                            </div>
                                        </v-col>
                                            
                                    </v-row>                   
                                    <v-data-table
                                    :headers="headers"
                                    :items="getSchema"
                                    :loading="loading"
                                    v-model:items-per-page="itemsPerPage"
                                    :search="search"
                                    :hover="true"                    
                                    density="compact">

                                        <template v-slot:item.index="{ index }">
                                            {{ ++index }}
                                        </template>  

                                        <template v-slot:item.merge_date="{ item }">
                                            {{ formattedDate(item.merge_date) }}
                                        </template>  
                                        
                                        
                                        <template v-slot:item.approval_status_display="{ item }">
                                            <v-chip
                                            v-if="item.approval_current_process && item.approval_current_process.status === 'Pending'"
                                            color="yellow-darken-3"
                                            size="small"
                                            >
                                                Wating for {{ item.approval_current_process.approval_step_name.name }}
                                            </v-chip>

                                            <v-chip
                                            v-else-if="item.approval_current_process && item.approval_current_process.status === 'Approved'"
                                            color="green"
                                            size="small"
                                            >
                                                Approved By {{ item.approval_current_process.approval_step_name.name }}
                                            </v-chip>

                                            <v-chip
                                            v-else-if="item.approval_current_process && item.approval_current_process.status === 'Approved'"
                                            color="red"
                                            size="small"
                                            >
                                                Cancelled By  {{ item.approval_current_process.approval_step_name.name }}
                                            </v-chip>
                                            <v-chip
                                            v-else
                                            color="green"
                                            size="small"
                                            >
                                                {{ item.approval_status }}
                                            </v-chip>
                                        </template>

                                        <template v-slot:item.pr_status="{ item }">
                                            <v-chip
                                                :color="statusMap[item.pr_status]?.color || 'grey'"
                                                size="small"
                                                class="text-capitalize"
                                            >
                                                {{ statusMap[item.pr_status]?.label || 'Unknown' }}
                                            </v-chip>
                                        </template>                                        

                                        <template v-slot:item.actions="{ item }">
                                            <v-btn
                                            icon="mdi-eye"
                                            size="small"
                                            variant="text"
                                            color="brown"
                                            @click="viewRequisition(item)"
                                            />

                                            <v-btn 
                                            color="orange" 
                                            size="small"
                                            variant="text"
                                            icon="mdi-pencil"
                                            @click="editItem(item)"
                                            v-if="$updateAccess($route.fullPath)"/>

                                            <v-btn
                                            icon="mdi-file-document"
                                            size="small"
                                            variant="text"
                                            color="blue"
                                            @click="viewRequisitionMergeInvoice(item)"
                                            v-if="$updateAccess($route.fullPath)"
                                            />
                                        </template>

                                    </v-data-table>             
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import {useStore} from 'vuex';
import { useField, useForm } from 'vee-validate';
import * as yup from 'yup';
import { ref } from 'vue';
import { toast } from 'vue3-toastify';
import formattedDate from '@/plugins/dateFormatter';
import statusMap from '@/utils/statusMap';
import purchaseApprovalStatus from "@/utils/purchaseApprovalStatus";

export default {
        components: {

        },
        data: () => ({
            itemsPerPage:10,
            panel: [0],
            loading:false,
            search: "",
            dialog: false,
            data:{},
            purchaseApprovalStatus,
            statusMap,
            headers: [
                { title: "#SL", align: "center", key: "index", width: "7%", sortable: false },
                { title: "Code", key: "code",align: "center" ,sortable: false },
                { title: "Empolyee Name",align: "center", key: "created_by.full_name", sortable: true },
                { title: "Merge Date" , align:"center",key:"merge_date" ,sortable: false},
                { title: "Approval Status", align: "center", key: "approval_status_display", sortable: true },
                { title: "CNC Status", align: "center", key: "pr_status", sortable: true },
                { title: "Actions", align: "center", key: "actions", sortable: false }
            ],
        }),
        watch: {
        },
        computed:{
            getSchema() {
                return this.$store.getters.getPurRequisitionMergeList;
            },
        },
        setup() {
            const { handleSubmit, resetForm} = useForm({
                validationSchema: yup.object({
                    // from_date: yup.date().required().label('Rfq Date'),
                    // department_id: yup.number().positive().integer().nullable().label('Department Name'),
                    // warehouse_id: yup.number().positive().integer().nullable().label('Warehouse Name'),                  
                }),
            });

            const from_date = useField('from_date');
            const to_date = useField('to_date');
            const errorMessages  = ref('');
            const loading  = ref('');
            const store = useStore();
            
            const submit = handleSubmit((values) => {
                loading.value = true;
                values.from_date = formattedDate(from_date.value.value);
                values.to_date = formattedDate(to_date.value.value);
                store.dispatch("getPurRequisitionMergeList", values)
                    .then((response) => {
                        loading.value = false;
                    })
                    .catch((error) => {            
                        toast.error(error.response.data.message);          
                    })
            });
            return {
                submit,
                from_date,
                to_date,
                errorMessages,
                loading
            }
        },
        methods: {
            formattedDate,
            goTo(val) {
                this.$router.push({ path: val }).catch((err) => {});
            },
            viewRequisition(item) {
            this.$router.push({ name: "cnc-requisition-view", params: { id: item.id } })
            },
            editItem(item){
                this.$router.push({ 
                    name: 'cnc-requisition-merge',
                    query: { id: item.id }
                });
            },

            viewRequisitionMergeInvoice(item) {
                this.$router.push({
                    name: "view-cnc-merge-invoice",
                    query: { id: item.id },
                });
            },
            exportToPDF() {
                let serialNumber = 1;
                const columns = ['#SL', 'Code', 'Employee Name', 'Merge Date', 'CNC Status'];
                const rows = this.getSchema.map(item => [serialNumber++, item.code, item.created_by.full_name, item.merge_date, statusMap[item.pr_status]?.label || 'Unknown']);
                this.$exportTableToPDF(columns,rows,'CNC Requisition Merge List','cnc_requisition_merge_list_' + this.$fileDate(),'landscape')
            },
            exportToExcel() {
                var data = [['#SL', 'Code', 'Employee Name', 'Merge Date', 'CNC Status']];
                var serialNumber = 1;
                this.getSchema.forEach(item => {
                    data.push([serialNumber++, item.code, item.created_by.full_name, item.merge_date, statusMap[item.pr_status]?.label || 'Unknown']);
                });
                this.$exportTableToExcel(data,'cnc_requisition_merge_list_' + this.$fileDate());
            },
            exportToCSV() {
                var data = [['#SL', 'Code', 'Employee Name', 'Merge Date', 'CNC Status']];
                var serialNumber = 1;
                this.getSchema.forEach(item => {
                    data.push([serialNumber++, item.code, item.created_by.full_name, item.merge_date, statusMap[item.pr_status]?.label || 'Unknown']);
                });

                this.$exportTableToCSV(data,'cnc_requisition_merge_list_' + this.$fileDate());
            },
        },
        mounted() {
            // this.from_date.value.value = new Date();
            // this.to_date.value.value = new Date();
            this.$nextTick(() => {
                this.$refs.searchButton.$el.click();
            });   
        }  
    }
</script>